(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["a-hp-collection-tabs"] && !Shopify.designMode) return;
  try {
    
	if (!customElements.get('l-hp-collection-tabs')) {
		class LTAHPCollectionTabs extends HTMLElement {
			constructor() {
				super()

				this.handleTabClick = this.handleTabClick.bind(this)
			}

			connectedCallback() {
				this.tabEls = this.querySelectorAll('[data-tab-button]')
				this.productTabsEls = this.querySelectorAll('[data-products]')

				this.tabEls.forEach((tabEl) => {
					tabEl.addEventListener('click', this.handleTabClick)
				})
			}

			disconnectedCallback() {
				if (this.tabEls) {
					this.tabEls.forEach((tabEl) => {
						tabEl.removeEventListener('click', this.handleTabClick)
					})
				}
			}

			handleTabClick(event) {
				const tabEl = event.currentTarget
				if (!tabEl) return
				const blockId = tabEl.getAttribute('data-tab-button')

				this.toggleProductTabs(blockId)
			}

			toggleProductTabs(blockId) {
				if (!blockId) return

				this.tabEls.forEach((tabEl) => {
					const isActive = tabEl.getAttribute('data-tab-button') === blockId
					tabEl.classList.toggle('is-active', isActive)
				})

				this.productTabsEls.forEach((productTabEl) => {
					const productBlockId = productTabEl.getAttribute('data-products')
					productTabEl.classList.toggle('l-hidden', productBlockId !== blockId)
				})
			}
		}

		customElements.define('l-hp-collection-tabs', LTAHPCollectionTabs)
	}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["a-main-collection"] && !Shopify.designMode) return;
  try {
    
	if (!customElements.get('l-plp')) {
		class LTAPlp extends HTMLElement {
			constructor() {
				super()

				this.onIntersect = this.onIntersect.bind(this)
			}

			connectedCallback() {
				this.gridEl = this.querySelector('[data-plp-grid]')
				this.sentinelEl = this.querySelector('[data-plp-sentinel]')
				this.loaderEl = this.querySelector('[data-plp-loader]')
				this.sectionId = this.dataset.sectionId
				this.isLoading = false
				this.loadedUrls = new Set()

				const configEl = this.querySelector('[data-plp-config]')
				if (configEl) {
					try {
						const config = JSON.parse(configEl.textContent)
						this.nextPageUrl = config.nextUrl || ''
					} catch {
						this.nextPageUrl = ''
					}
				} else {
					this.nextPageUrl = ''
				}

				if (!this.gridEl || !this.sentinelEl || !this.nextPageUrl || this.dataset.infiniteScroll === 'false') {
					return
				}

				const preloadOffset = Math.round(window.innerHeight)

				this.observer = new IntersectionObserver(this.onIntersect, {
					rootMargin: `0px 0px ${preloadOffset}px 0px`,
				})
				this.observeSentinel()
			}

			disconnectedCallback() {
				this.observer?.disconnect()
			}

			observeSentinel() {
				if (this.observer && this.sentinelEl) {
					this.observer.observe(this.sentinelEl)
				}
			}

			unobserveSentinel() {
				if (this.observer && this.sentinelEl) {
					this.observer.unobserve(this.sentinelEl)
				}
			}

			getExistingProductIds() {
				return new Set(
					[...this.gridEl.querySelectorAll('[data-plp-item]')].map((item) => item.dataset.productId).filter(Boolean)
				)
			}

			getSectionRoot(template) {
				return (
					template.content.getElementById(`shopify-section-${this.sectionId}`) ||
					template.content.querySelector('[data-plp-grid]')?.closest('.shopify-section') ||
					template.content
				)
			}

			onIntersect(entries) {
				if (entries.some((entry) => entry.isIntersecting)) {
					this.loadMore()
				}
			}

			setLoadingState(isLoading) {
				this.isLoading = isLoading
				this.classList.toggle('is-loading', isLoading)

				if (this.loaderEl) {
					this.loaderEl.setAttribute('aria-busy', isLoading ? 'true' : 'false')
				}
			}

			initOkendoWidgets() {
				window.okeWidgetApi?.initAllWidgets?.()
			}

			async loadMore() {
				if (this.isLoading || !this.nextPageUrl) return

				const fetchUrl = this.nextPageUrl
				if (this.loadedUrls.has(fetchUrl)) {
					this.nextPageUrl = ''
					this.unobserveSentinel()
					this.sentinelEl?.remove()
					return
				}

				this.isLoading = true
				this.unobserveSentinel()
				this.setLoadingState(true)

				try {
					const url = new URL(fetchUrl, window.location.origin)
					url.searchParams.set('section_id', this.sectionId)

					const response = await fetch(url.toString())
					if (!response.ok) return

					const html = await response.text()
					const template = document.createElement('template')
					template.innerHTML = html.trim()

					const sectionRoot = this.getSectionRoot(template)
					const fetchedGrid = sectionRoot.querySelector('[data-plp-grid]')
					if (!fetchedGrid) return

					const existingProductIds = this.getExistingProductIds()
					const items = [...fetchedGrid.querySelectorAll('[data-plp-item]')].filter(
						(item) => !existingProductIds.has(item.dataset.productId)
					)

					items.forEach((item) => this.gridEl.appendChild(item))

					if (items.length > 0) {
						this.initOkendoWidgets()
					}

					this.loadedUrls.add(fetchUrl)

					const nextLink = sectionRoot.querySelector('[data-plp-next-url]')
					const nextPageUrl = nextLink?.getAttribute('href') || ''

					if (nextPageUrl && nextPageUrl !== fetchUrl && !this.loadedUrls.has(nextPageUrl)) {
						this.nextPageUrl = nextPageUrl

						const configEl = this.querySelector('[data-plp-config]')
						if (configEl) {
							configEl.textContent = JSON.stringify({ nextUrl: this.nextPageUrl })
						}
					} else {
						this.nextPageUrl = ''
						this.sentinelEl?.remove()
					}
				} finally {
					this.isLoading = false
					this.setLoadingState(false)

					if (this.nextPageUrl && this.sentinelEl?.isConnected) {
						this.observeSentinel()
					}
				}
			}
		}

		customElements.define('l-plp', LTAPlp)
	}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["a-stix-sticky-bar"] && !Shopify.designMode) return;
  try {
    
	if (!customElements.get('l-stix-sticky-bar')) {
		class LStixStickyBar extends HTMLElement {
			constructor() {
				super()
				this.handleScroll = this.handleScroll.bind(this)
			}

			connectedCallback() {
				this.handleScroll()
				window.addEventListener('scroll', this.handleScroll, { passive: true })
			}

			disconnectedCallback() {
				window.removeEventListener('scroll', this.handleScroll)
			}

			handleScroll() {
				const shouldShow = window.scrollY > 300
				this.parentElement.classList.toggle('is-visible', shouldShow)
			}
		}

		customElements.define('l-stix-sticky-bar', LStixStickyBar)
	}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["a-top-seller-products"] && !Shopify.designMode) return;
  try {
    
	if (!customElements.get('l-top-seller-products')) {
		class LTATopSellerProducts extends HTMLElement {
			constructor() {
				super()

				this.handleTabClick = this.handleTabClick.bind(this)
			}

			connectedCallback() {
				this.tabEls = this.querySelectorAll('[data-tab-button]')
				this.productTabsEls = this.querySelectorAll('[data-products]')

				this.tabEls.forEach((tabEl) => {
					tabEl.addEventListener('click', this.handleTabClick)
				})
			}

			disconnectedCallback() {
				if (this.tabEls) {
					this.tabEls.forEach((tabEl) => {
						tabEl.removeEventListener('click', this.handleTabClick)
					})
				}
			}

			handleTabClick(event) {
				const tabEl = event.currentTarget
				if (!tabEl) return

				const blockId = tabEl.getAttribute('data-tab-button')
				this.toggleProductTabs(blockId)
			}

			toggleProductTabs(blockId) {
				if (!blockId) return

				const nextPanel = Array.from(this.productTabsEls).find(
					(panelEl) => panelEl.getAttribute('data-products') === blockId
				)
				const currentPanel = Array.from(this.productTabsEls).find((panelEl) => panelEl.classList.contains('is-active'))

				if (!nextPanel || nextPanel === currentPanel) return

				this.tabEls.forEach((tabEl) => {
					const isActive = tabEl.getAttribute('data-tab-button') === blockId
					tabEl.classList.toggle('is-active', isActive)
				})

				const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches

				if (prefersReducedMotion || !currentPanel) {
					if (currentPanel) {
						currentPanel.classList.remove('is-active', 'is-entering', 'is-leaving')
					}

					nextPanel.classList.remove('is-entering', 'is-leaving')
					nextPanel.classList.add('is-active')
					this.updatePanelSwiper(nextPanel)
					return
				}

				const onLeave = (event) => {
					if (event.target !== currentPanel || event.propertyName !== 'transform') return

					currentPanel.removeEventListener('transitionend', onLeave)
					currentPanel.classList.remove('is-leaving')

					nextPanel.classList.add('is-active', 'is-entering')

					requestAnimationFrame(() => {
						requestAnimationFrame(() => {
							nextPanel.classList.remove('is-entering')
							this.updatePanelSwiper(nextPanel)
						})
					})
				}

				currentPanel.classList.add('is-leaving')
				currentPanel.classList.remove('is-active')
				currentPanel.addEventListener('transitionend', onLeave)
			}

			updatePanelSwiper(panelEl) {
				const swiperEl = panelEl?.querySelector('l-swiper-carousel')
				if (!swiperEl?.swiperCarousel) return

				swiperEl.swiperCarousel.update()

				if (typeof swiperEl.setupNavigation === 'function') {
					swiperEl.setupNavigation()
				}
			}
		}

		customElements.define('l-top-seller-products', LTATopSellerProducts)
	}

  } catch(e) { console.error(e); }
})();
})();
